import { createRoot } from 'react-dom/client';

import ContraintsLegend from '../../../ContraintsLegend/ContraintsLegend.jsx';

import './constraints-legend-control.css';

class ConstraintsLegendControl {
  onAdd() {
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl constraints-legend-control';
    this._root = createRoot(this._container);
    this._props = { legends: [], layerOpacities: {}, onOpacityChange: () => {} };
    this.render();

    return this._container;
  }

  onRemove() {
    if (this._root) {
      queueMicrotask(() => {
        this._root.unmount();
      });
    }
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
    this._container = null;
  }

  update(props) {
    this._props = props;
    this.render();
  }

  render() {
    if (!this._root) return;

    this._container.hidden = this._props.legends.length === 0;
    this._root.render(<ContraintsLegend {...this._props} />);
  }
}

export default ConstraintsLegendControl;
